import ButtonLoader from "../AsyncState/ButtonLoader";

export default function GradientBlue({type, value, onClick="", loading=false, disabled=false, loadingLabel="در حال انجام"}) {
  return (
    <button
      className="w-full bg-zi-gradient-button-blue text-zi-gray-light text-base py-2 rounded-lg cursor-pointer outline-none hocus:ring-offset-1 hocus:ring-1 hocus:ring-zi-blue-light"
      type={type}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
    >
      {loading ? <ButtonLoader label={loadingLabel} /> : value}
    </button>
  )
}
